import React from "react";
import { Box, Button, Modal, useTheme } from "@mui/material";
import { CustomTypography } from "../../custom-typography/custom-typography";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {
  modalStyles,
  backdropStyles,
  getModalContentStyles,
  warningHeaderStyles,
  warningIconStyles,
  warningTextStyles,
  buttonsContainerStyles,
  getButtonBaseStyles,
} from "./styles";

interface MobileWarningModalProps {
  open: boolean;
  onContinue: () => void;
  onExit: () => void;
}

export const MobileWarningModal: React.FC<MobileWarningModalProps> = ({
  open,
  onContinue,
  onExit,
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Modal
      open={open}
      onClose={onExit}
      disableEscapeKeyDown={false}
      sx={modalStyles}
    >
      <Box
        sx={backdropStyles}
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            onExit();
          }
        }}
      >
        <Box
          sx={getModalContentStyles(isDark)}
          onClick={(e) => e.stopPropagation()}
        >
          <Box sx={warningHeaderStyles}>
            <WarningAmberIcon sx={warningIconStyles} />
            <CustomTypography
              fontSize={14}
              fontWeight={500}
              color="#FFFFFF"
              sx={warningTextStyles}
            >
              Coaching may not work well on mobile devices.
            </CustomTypography>
          </Box>

          <Box sx={buttonsContainerStyles}>
            <Button
              variant="contained"
              onClick={onContinue}
              sx={getButtonBaseStyles(isDark)}
            >
              Continue
            </Button>
            <Button
              variant="outlined"
              onClick={onExit}
              sx={getButtonBaseStyles(isDark)}
            >
              Exit
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
